export default {
  data: () => ({
    requeridoRegla: [
      v => !!v || 'Requerido'
      // v => !!v || 'Requerido',
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters'
    ],
    dniRegla: [
      v => (v && v.length >= 8) || 'DNI incompleto'
    ],
    operacionRegla: [
      v => (v && v.length >= 8) || 'Número de operación incompleto'
    ],
    rucRegla: [
      v => (v && v.length >= 11) || 'RUC incompleto'
    ],
    emailRegla: [
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Correo debe ser válido'
    ],
    emailOpcionalRegla: [
      v => /^$|^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Correo debe ser válido'
    ]
  }),
  methods: {
    crearSolicitud () {
      var solicitudApi = {
        tokenId: encodeURIComponent(localStorage.getItem('tokenId')),
        local: localStorage.getItem('local')
      }
      return solicitudApi
    },
    formatoFecha (fecha) {
      if (!fecha) return null
      const [year, month, day] = fecha.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (fecha) {
      if (!fecha) return null
      const [day, month, year] = fecha.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins.js